import { isDefined } from '@grandvisionhq/utils';
import '@bloomreach/spa-sdk';
import { isCmsPrescriptionEntryKey } from '../types/typeguards.js';

function getPrescriptionEntryList(prescriptionStepEntryTypes) {
    if (!prescriptionStepEntryTypes || prescriptionStepEntryTypes.length === 0) {
        return undefined;
    }
    const entryTypes = prescriptionStepEntryTypes.map((item)=>{
        var ref;
        if (!isCmsPrescriptionEntryKey(item.key)) return null;
        return {
            key: item.key,
            title: item.iconTextCompound[0].text,
            icon: !!((ref = item.iconTextCompound[0]) === null || ref === void 0 ? void 0 : ref.icon) ? item.iconTextCompound[0].icon : undefined,
            description: !!item.description.value ? item.description.value : undefined,
            ctaLabel: !!item.ctaLabel ? item.ctaLabel : undefined
        };
    });
    return entryTypes.filter(isDefined);
}

export { getPrescriptionEntryList };
//# sourceMappingURL=get-prescription-entry-list.js.map
